import React from 'react';
import { connect } from 'react-redux';
import { actions, signinActions } from '../../actions';
import { isNotLogged, modalPaths } from '../ScrollReader/helpers';
import { WhiteLink } from '../design/buttons';
import AccountNav from '../design/topBar/AccountNav';
import UserThumbnail from '../design/topBar/UserThumbnail';
import LanguagesMenu from './LanguagesMenu';
import * as socialControlsActions from '../../actions/socialControlsActions';

class UserMenu extends React.Component {

  render() {
    if (isNotLogged()) {
      return (
        <div>
          <WhiteLink
            text={this.props.t.sign_in_up}
            className="right nowrap"
            path={`#${modalPaths.signIn}`}
            onClick={this.props.onLoginSignUpClick}
          />
          <LanguagesMenu />
        </div>
      );
    } else {
      return (
        <div className="mr5 relative">
          <div className="right xs-hide a-user-login-name-box">
            <WhiteLink
              text={this.props.user && this.props.user.display_name}
              className={`right block truncate pr3 a-user-menu-link ${this.props.caretIcon}`}
              onClick={this.props.toggleUserMenu}
            />
          </div>
          <div className="right relative sm-mr1 a-user-thumbnail-box">
            <UserThumbnail
              count={this.props.notificationCount}
              img={this.props.user && this.props.user.mini_thumbnail_url}
              withCounter={true}
            />
          </div>
          <LanguagesMenu />
          { this.props.opened &&
            <AccountNav { ...this.props } />
          }
        </div>
      );
    }
  }
}

const mapState = (state, ownProps) => ({
  caretIcon: ` caret-${state.signin.userMenuOpened ? 'up' : 'down'}`,
  opened: state.signin.userMenuOpened,
  t: I18n.t('components.webreader_header_menu'),
  user: state.currentUser.user,
  notificationCount: state.currentUser.user && state.currentUser.user.notification_count
});

const mapDispatch = (dispatch, ownProps) => ({
  onLoginSignUpClick: () => {
    isNotLogged() && dispatch(signinActions.openModal());
    dispatch(actions.episodesControlsSetClosed());
  },
  toggleUserMenu: () => {
    dispatch(actions.episodesControlsSetClosed());
    dispatch(socialControlsActions.closeDrawer());
    dispatch(socialControlsActions.closeSocialDropdown());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeModal());
    dispatch(signinActions.toggleUserMenu());
  },
  onSignOutClick: signOut
});

export default connect(mapState, mapDispatch)(UserMenu);
